module.exports = __webpack_public_path__ + "nc_static/media/service_contract_right_mark.4a314e66.svg";